import { Alert as MuiAlert } from '@mui/material';
import { alertClasses, AlertProps as MuiAlertProps } from '@mui/material/Alert';
import { styled } from '@mui/material/styles';

import { tokens } from '../../theme/styles/themeMui';

export type AlertSeverity = NonNullable<MuiAlertProps['severity']>;
export type AlertProps = MuiAlertProps;

export const Alert: React.ComponentType<AlertProps> = styled(MuiAlert)<AlertProps>(
  ({ theme, severity }) => ({
    color: theme.palette.colors.content.primary,
    display: 'flex,',
    padding: '16px',
    gap: '16px',
    alignSelf: 'stretch',
    alignItems: 'center',
    [`.${alertClasses.message}`]: {
      padding: 0,
      ...tokens.typography.labelPrimary,
    },
    [`.${alertClasses.icon}`]: {
      marginRight: 0,
      padding: 0,
      fontSize: '24px',
      alignSelf: 'flex-start',
    },
    [`.${alertClasses.action}`]: {
      alignSelf: 'flex-start',
      padding: 0,
      marginRight: 0,
      [`.MuiButtonBase-root`]: {
        padding: 0,
        fontSize: '24px',
      },
      [`.MuiSvgIcon-root`]: {
        fontSize: '24px',
      },
    },
    ...(severity === 'success' && {
      backgroundColor: theme.palette.colors.bg['positive-secondary'],
    }),

    ...(severity === 'alert' && {
      backgroundColor: theme.palette.colors.bg['danger-secondary'],
      [`.${alertClasses.icon} .MuiSvgIcon-root`]: {
        fill: theme.palette.colors.content['danger-secondary'],
      },
    }),

    ...(severity === 'warning' && {
      backgroundColor: theme.palette.colors.bg['warning-secondary'],
      [`.${alertClasses.icon} .MuiSvgIcon-root`]: {
        fill: theme.palette.colors.content['warning-secondary'],
      },
    }),

    ...(severity === 'info' && {
      backgroundColor: theme.palette.colors.bg['promo-secondary'],
    }),

    ...(severity === 'promotion' && {
      borderRadius: '8px',
      border: `1px solid ${theme.palette.colors.border.separator}`,
    }),
  }),
);
